import { combineReducers } from 'redux';
import { schedule } from '@breezeway/brzw-react-core';

export default combineReducers({
  dates: schedule.reducers.dates,
  filters: schedule.reducers.filters,
  propertyReservations: schedule.reducers.propertyReservations,
  propertyTasksByDate: schedule.reducers.propertyTasksByDate,
  propertyTaskDraftsByDate: schedule.reducers.propertyTaskDraftsByDate,
  reservationsCheckinsByDate: schedule.reducers.reservationsCheckinsByDate,
  reservationsCheckoutsByDate: schedule.reducers.reservationsCheckoutsByDate,
  personTasksByDate: schedule.reducers.personTasksByDate,
  personTaskDraftsByDate: schedule.reducers.personTaskDraftsByDate,
  nextReservations: schedule.reducers.nextReservations,
  tasksSummary: schedule.reducers.tasksSummary,
  monthlySummary: schedule.reducers.monthlySummary,
});
